import { render, staticRenderFns } from "./ComboBox.vue?vue&type=template&id=ef20fa88"
import script from "./ComboBox.vue?vue&type=script&lang=js"
export * from "./ComboBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports